import React from 'react';
import { T, useTheme, Ico, Badge } from '../../../design';

export interface PersonRowProps {
  name: string;
  sub?: string;
  right?: React.ReactNode;
  onClick?: (() => void) | null;
  selected?: boolean;
  selectable?: boolean;
  owner?: boolean;
}

export function PersonRow({ name, sub, right, onClick, selected, selectable, owner }: PersonRowProps) {
  const t = useTheme();
  return (
    <div onClick={onClick ?? undefined} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', borderTop: `1px solid ${T.borderLight}`, cursor: onClick ? 'pointer' : 'default' }}>
      {selectable && <span style={{ width: 22, height: 22, borderRadius: 7, border: `1.5px solid ${selected ? t.accent : T.border}`, background: selected ? t.accent : 'transparent', color: T.onAccent, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{selected && <Ico.check size={14} />}</span>}
      <span style={{ width: 36, height: 36, borderRadius: 999, background: T.accentLight, color: t.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 13, flexShrink: 0 }}>{name.split(' ').map((s) => s[0]).slice(0, 2).join('')}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: T.fg, display: 'flex', alignItems: 'center', gap: 6 }}>{name}{owner && <Badge tone="accent">Ejer</Badge>}</div>
        {sub && <div style={{ fontSize: 12, color: T.fg3, fontWeight: 600, marginTop: 2 }}>{sub}</div>}
      </div>
      {right}
    </div>
  );
}
